module.exports = __webpack_public_path__ + "static/media/ab202411-9afe-4702-bdc6-79c7c4b67aba.090db470.png";